import {
  BookingPurchaseOrderBadge,
  BookingStatusBadge,
} from '@rematter/modules/customer-portal/_components/bookings/BookingBadges';
import { EntityDetails } from '@rematter/ui-web';
import { useAtom, useAtomValue } from 'jotai';

import * as state from '../../_state/bookingDetails.state';
import { customerPortalRoutes } from '../../routes';
import { EntityTabLoads } from '../_shared/EntityTabLoads';

import { BookingHeaderActions } from './BookingHeaderActions';
import { BookingTabInfo } from './BookingTabInfo';

import { useModuleLocation } from '~/shared/hooks/useModuleLocation';

export const BookingDetailsView = () => {
  const [, navigate] = useModuleLocation();
  const [tab = 'bookingInfo', setTab] = useAtom(state.$tab);

  const { data: booking } = useAtomValue(state.$bookingDetails);

  const handleBackPressed = () => navigate(customerPortalRoutes.bookings);

  return (
    <EntityDetails
      className="@BookingDetailsView"
      onChangeTab={(tab) => setTab(tab, { replace: true })}
      currentTab={tab}
      onBackPressed={handleBackPressed}
      primaryTitle={booking?.supplier?.name ?? 'Loading...'}
      secondaryTitle={
        booking?.documentNumber
          ? `Booking #${String(booking.documentNumber).padStart(6, '0')}`
          : undefined
      }
      badges={
        <>
          {booking?.purchaseOrderNumber && (
            <BookingPurchaseOrderBadge
              purchaseOrderNumber={booking?.purchaseOrderNumber}
            />
          )}
          {booking?.status && <BookingStatusBadge status={booking.status} />}
        </>
      }
      headerActions={<BookingHeaderActions booking={booking} />}
      tabs={{
        bookingInfo: {
          title: 'Booking Info',
          content: BookingTabInfo,
        },
        loads: {
          title: 'Loads',
          content: EntityTabLoads,
        },
      }}
    />
  );
};
